import styled from 'styled-components';
import { Select } from 'antd';

export const DropdownUserRoleStyles = styled.div`
  .select-status-fallback-wrapper {
    display: inline-flex;
    position: relative;
    .ant-select-selector {
      pointer-events: none;
    }
    .action-feature-icon {
      position: absolute;
      top: -12px;
      right: -9px;
      font-size: 20px;
      color: ${({ theme }) => theme.subscriptions.colorIcon};
    }
  }
`;

export const DropDownWrapper = styled(Select)`
  .span-option-status {
    padding: 5px 10px;
    border-radius: 8px;
    font-weight: 600;
  }
  .ant-select-arrow {
    color: ${({ theme }) => theme.palette.primary};
  }
  .ant-select-selector {
    border: 1px solid #f2f2f2 !important;
    box-sizing: border-box;
    border-radius: 8px;
  }
  &.ant-select-focused .ant-select-selector {
    border-color: ${({ theme }) => theme.palette.primary} !important;
  }
`;
